import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { AddressDetailsPayloadType } from "./AddressDetails.types";

interface AddressDetailsState {}

const initialState: AddressDetailsState = {};

const addressDetailsSlice = createSlice({
  name: "addressDetails",
  initialState,
  reducers: {
    submitAddressDetailsForm(state, action: PayloadAction<AddressDetailsPayloadType>) {
      return state;
    },
    destroy() {
      return initialState;
    }
  }
});


export default addressDetailsSlice.reducer;
export const {
  submitAddressDetailsForm,
  destroy
} = addressDetailsSlice.actions;
export const addressDetailsActions = addressDetailsSlice.actions;
